import { Injectable, inject, Type, InjectionToken, Injector, effect, EffectRef } from '@angular/core';

/**
 * Ref - Servicio para acceder a dependencias desde Notifiers
 * Equivalente al 'ref' de Riverpod en Flutter
 */
@Injectable({ providedIn: 'root' })
export class Ref {
  private readonly injector = inject(Injector);

  /**
   * Obtiene el valor de otro provider (sin suscribirse)
   * Usa 'read' para ser consistente con Vue y Flutter
   */
  read<T>(provider: Type<T> | InjectionToken<T>): T {
    return this.injector.get(provider);
  }

  /**
   * Crea un effect() con el injector del Ref
   * Útil para que los notifiers se suscriban a signals sin DI
   */
  createEffect(fn: () => void): EffectRef {
    return effect(fn, { injector: this.injector });
  }
}
